<template>
  <div class="faqs-page">
    <!-- Navigation Bar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top">
      <div class="container">
        <a class="navbar-brand d-flex align-items-center" href="#home">
          <img src="https://pona.paysol.africa/logos/pona.png" alt="PONA HEALTH-X Logo" height="50" class="me-3">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">

          <ul class="navbar-nav ms-auto align-items-center">
            <li class="nav-item">
              <a class="nav-link" href="javascript: void(0);" @click="goToPage('/')">Home</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="javascript: void(0);"   @click="goToPage('about')">About</a>
            </li>
            <li class="nav-item d-none">
              <a class="nav-link" href="#how-it-works">How It Works</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#benefits">Benefits</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#services">Health Services</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#enrollment">Enrollment</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#facilities">Health Facilities</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#faqs">FAQs</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#contact">Contact</a>
            </li>

            <li class="nav-item dropdown ms-3">
              <button class="btn btn-primary dropdown-toggle" type="button"
                      id="loginDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bx bx-user me-2"></i>Login
              </button>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="loginDropdown">
                <li>
                  <a class="dropdown-item" @click="goToMemberLogin">
                    <i class="bx bx-user-circle me-2"></i>Member Portal
                  </a>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li>
                  <a class="dropdown-item" @click="goToStaffLogin">
                    <i class="bx bx-briefcase me-2"></i>Staff Login
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Page Header -->
    <section class="page-header">
      <div class="header-pattern"></div>
      <div class="container">
        <div class="row align-items-center min-vh-40 py-5">
          <div class="col-lg-8 mx-auto text-center text-white position-relative z-2">
            <nav aria-label="breadcrumb" class="mb-4 justify-content-center d-flex">
              <ol class="breadcrumb breadcrumb-light">
                <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">FAQs</li>
              </ol>
            </nav>
            <h1 class="display-3 fw-bold mb-4 animate-on-scroll text-white">
              Frequently Asked Questions
            </h1>
            <p class="lead mb-4 animate-on-scroll">
              Find answers to common questions about PONA HEALTH-X membership, coverage,
              enrollment, and healthcare services.
            </p>

            <!-- Search Box -->
            <div class="faq-search animate-on-scroll">
              <div class="search-box">
                <i class="bx bx-search"></i>
                <input type="text"
                       v-model="searchQuery"
                       placeholder="Search for answers..."
                       @input="filterFAQs">
                <button class="search-clear" v-if="searchQuery" @click="clearSearch">
                  <i class="bx bx-x"></i>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <!-- Quick Stats -->
    <section class="quick-stats-section">
      <div class="container">
        <div class="quick-stats-card animate-on-scroll">
          <div class="row g-4">
            <div class="col-md-3 col-6" v-for="stat in quickStats" :key="stat.label">
              <div class="quick-stat-item">
                <div class="qs-icon" :class="'bg-' + stat.color">
                  <i :class="stat.icon"></i>
                </div>
                <div class="qs-content">
                  <span class="qs-value">{{ stat.value }}</span>
                  <span class="qs-label">{{ stat.label }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ Categories Navigation -->
    <section class="py-5 bg-white">
      <div class="container">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-category"></i></span>
            <span class="label-text">Categories</span>
          </div>
          <h2 class="display-6 fw-bold mb-3">Browse by Topic</h2>
          <p class="text-muted">Select a category to find relevant answers quickly</p>
        </div>

        <div class="category-grid animate-on-scroll">
          <div class="category-card"
               v-for="category in faqCategories"
               :key="category.id"
               :class="{ 'active': activeCategory === category.id }"
               @click="selectCategory(category.id)">
            <div class="category-icon" :class="'bg-' + category.color">
              <i :class="category.icon"></i>
            </div>
            <h6 class="fw-bold mb-1">{{ category.name }}</h6>
            <span class="category-count">{{ category.count }} Questions</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Search Results (if searching) -->
    <section class="py-5 bg-light" v-if="searchQuery && filteredFAQs.length > 0">
      <div class="container">
        <div class="search-results-header animate-on-scroll">
          <h4 class="fw-bold mb-0">
            <i class="bx bx-search me-2 text-primary"></i>
            Search Results for "{{ searchQuery }}"
          </h4>
          <span class="results-count">{{ filteredFAQs.length }} results found</span>
        </div>

        <div class="accordion faq-accordion" id="searchResultsAccordion">
          <div class="accordion-item animate-on-scroll" v-for="(faq, index) in filteredFAQs" :key="'search-' + index">
            <h2 class="accordion-header">
              <button class="accordion-button collapsed" type="button"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#searchResult' + index">
                <div class="faq-question">
                  <span class="faq-category-tag" :class="'tag-' + faq.categoryColor">
                    {{ faq.categoryName }}
                  </span>
                  <span class="question-text">{{ faq.question }}</span>
                </div>
              </button>
            </h2>
            <div :id="'searchResult' + index" class="accordion-collapse collapse"
                 data-bs-parent="#searchResultsAccordion">
              <div class="accordion-body">
                <p>{{ faq.answer }}</p>
                <div class="faq-helpful" v-if="faq.helpful !== undefined">
                  <span class="helpful-label">Was this helpful?</span>
                  <button class="helpful-btn" @click="markHelpful(faq, true)">
                    <i class="bx bx-like"></i> Yes
                  </button>
                  <button class="helpful-btn" @click="markHelpful(faq, false)">
                    <i class="bx bx-dislike"></i> No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- No Results -->
    <section class="py-5 bg-light" v-if="searchQuery && filteredFAQs.length === 0">
      <div class="container">
        <div class="no-results animate-on-scroll">
          <div class="no-results-icon">
            <i class="bx bx-search-alt"></i>
          </div>
          <h4 class="fw-bold mb-2">No Results Found</h4>
          <p class="text-muted mb-4">We couldn't find any FAQs matching "{{ searchQuery }}"</p>
          <button class="btn btn-primary" @click="clearSearch">
            <i class="bx bx-refresh me-2"></i>Clear Search
          </button>
        </div>
      </div>
    </section>

    <!-- FAQ Sections -->
    <section class="py-5 bg-light" v-if="!searchQuery">
      <div class="container">
        <!-- General Questions -->
        <div class="faq-section animate-on-scroll" id="general" v-show="activeCategory === 'all' || activeCategory === 'general'">
          <div class="faq-section-header">
            <div class="section-icon bg-primary">
              <i class="bx bx-help-circle"></i>
            </div>
            <div>
              <h3 class="fw-bold mb-1">General Questions</h3>
              <p class="text-muted mb-0">Basic information about PONA HEALTH-X</p>
            </div>
          </div>

          <div class="accordion faq-accordion" id="generalAccordion">
            <div class="accordion-item" v-for="(faq, index) in generalFAQs" :key="'general-' + index">
              <h2 class="accordion-header">
                <button class="accordion-button" :class="{ collapsed: index !== 0 }"
                        type="button" data-bs-toggle="collapse"
                        :data-bs-target="'#general' + index">
                  <i class="bx bx-help-circle me-3 text-primary"></i>
                  {{ faq.question }}
                </button>
              </h2>
              <div :id="'general' + index"
                   class="accordion-collapse collapse"
                   :class="{ show: index === 0 }"
                   data-bs-parent="#generalAccordion">
                <div class="accordion-body">{{ faq.answer }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Enrollment Questions -->
        <div class="faq-section animate-on-scroll" id="enrollment" v-show="activeCategory === 'all' || activeCategory === 'enrollment'">
          <div class="faq-section-header">
            <div class="section-icon bg-success">
              <i class="bx bx-user-plus"></i>
            </div>
            <div>
              <h3 class="fw-bold mb-1">Enrollment & Registration</h3>
              <p class="text-muted mb-0">How to join and register for PONA HEALTH-X</p>
            </div>
          </div>

          <div class="accordion faq-accordion" id="enrollmentAccordion">
            <div class="accordion-item" v-for="(faq, index) in enrollmentFAQs" :key="'enrollment-' + index">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#enrollment' + index">
                  <i class="bx bx-help-circle me-3 text-success"></i>
                  {{ faq.question }}
                </button>
              </h2>
              <div :id="'enrollment' + index" class="accordion-collapse collapse"
                   data-bs-parent="#enrollmentAccordion">
                <div class="accordion-body">{{ faq.answer }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Coverage Questions -->
        <div class="faq-section animate-on-scroll" id="coverage" v-show="activeCategory === 'all' || activeCategory === 'coverage'">
          <div class="faq-section-header">
            <div class="section-icon bg-info">
              <i class="bx bx-shield-check"></i>
            </div>
            <div>
              <h3 class="fw-bold mb-1">Coverage & Benefits</h3>
              <p class="text-muted mb-0">What's covered under PONA HEALTH-X</p>
            </div>
          </div>

          <div class="accordion faq-accordion" id="coverageAccordion">
            <div class="accordion-item" v-for="(faq, index) in coverageFAQs" :key="'coverage-' + index">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#coverage' + index">
                  <i class="bx bx-help-circle me-3 text-info"></i>
                  {{ faq.question }}
                </button>
              </h2>
              <div :id="'coverage' + index" class="accordion-collapse collapse"
                   data-bs-parent="#coverageAccordion">
                <div class="accordion-body">{{ faq.answer }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Premiums Questions -->
        <div class="faq-section animate-on-scroll" id="premiums" v-show="activeCategory === 'all' || activeCategory === 'premiums'">
          <div class="faq-section-header">
            <div class="section-icon bg-warning">
              <i class="bx bx-money"></i>
            </div>
            <div>
              <h3 class="fw-bold mb-1">Premiums & Payments</h3>
              <p class="text-muted mb-0">Payment information and premium plans</p>
            </div>
          </div>

          <div class="accordion faq-accordion" id="premiumsAccordion">
            <div class="accordion-item" v-for="(faq, index) in premiumsFAQs" :key="'premiums-' + index">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#premiums' + index">
                  <i class="bx bx-help-circle me-3 text-warning"></i>
                  {{ faq.question }}
                </button>
              </h2>
              <div :id="'premiums' + index" class="accordion-collapse collapse"
                   data-bs-parent="#premiumsAccordion">
                <div class="accordion-body">{{ faq.answer }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Facilities Questions -->
        <div class="faq-section animate-on-scroll" id="facilities" v-show="activeCategory === 'all' || activeCategory === 'facilities'">
          <div class="faq-section-header">
            <div class="section-icon bg-purple">
              <i class="bx bx-hospital"></i>
            </div>
            <div>
              <h3 class="fw-bold mb-1">Health Facilities</h3>
              <p class="text-muted mb-0">Finding and visiting facilities</p>
            </div>
          </div>

          <div class="accordion faq-accordion" id="facilitiesAccordion">
            <div class="accordion-item" v-for="(faq, index) in facilitiesFAQs" :key="'facilities-' + index">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#facilities' + index">
                  <i class="bx bx-help-circle me-3 text-purple"></i>
                  {{ faq.question }}
                </button>
              </h2>
              <div :id="'facilities' + index" class="accordion-collapse collapse"
                   data-bs-parent="#facilitiesAccordion">
                <div class="accordion-body">{{ faq.answer }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Services Questions -->
        <div class="faq-section animate-on-scroll" id="services" v-show="activeCategory === 'all' || activeCategory === 'services'">
          <div class="faq-section-header">
            <div class="section-icon bg-danger">
              <i class="bx bx-first-aid"></i>
            </div>
            <div>
              <h3 class="fw-bold mb-1">Healthcare Services</h3>
              <p class="text-muted mb-0">Services available to members</p>
            </div>
          </div>

          <div class="accordion faq-accordion" id="servicesAccordion">
            <div class="accordion-item" v-for="(faq, index) in servicesFAQs" :key="'services-' + index">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#services' + index">
                  <i class="bx bx-help-circle me-3 text-danger"></i>
                  {{ faq.question }}
                </button>
              </h2>
              <div :id="'services' + index" class="accordion-collapse collapse"
                   data-bs-parent="#servicesAccordion">
                <div class="accordion-body">{{ faq.answer }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Card & Membership Questions -->
        <div class="faq-section animate-on-scroll" id="membership" v-show="activeCategory === 'all' || activeCategory === 'membership'">
          <div class="faq-section-header">
            <div class="section-icon bg-teal">
              <i class="bx bx-id-card"></i>
            </div>
            <div>
              <h3 class="fw-bold mb-1">Membership Card</h3>
              <p class="text-muted mb-0">Card usage and management</p>
            </div>
          </div>

          <div class="accordion faq-accordion" id="membershipAccordion">
            <div class="accordion-item" v-for="(faq, index) in membershipFAQs" :key="'membership-' + index">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#membership' + index">
                  <i class="bx bx-help-circle me-3 text-teal"></i>
                  {{ faq.question }}
                </button>
              </h2>
              <div :id="'membership' + index" class="accordion-collapse collapse"
                   data-bs-parent="#membershipAccordion">
                <div class="accordion-body">{{ faq.answer }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Renewal Questions -->
        <div class="faq-section animate-on-scroll" id="renewal" v-show="activeCategory === 'all' || activeCategory === 'renewal'">
          <div class="faq-section-header">
            <div class="section-icon bg-orange">
              <i class="bx bx-refresh"></i>
            </div>
            <div>
              <h3 class="fw-bold mb-1">Renewal & Updates</h3>
              <p class="text-muted mb-0">Renewing and updating membership</p>
            </div>
          </div>

          <div class="accordion faq-accordion" id="renewalAccordion">
            <div class="accordion-item" v-for="(faq, index) in renewalFAQs" :key="'renewal-' + index">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#renewal' + index">
                  <i class="bx bx-help-circle me-3 text-orange"></i>
                  {{ faq.question }}
                </button>
              </h2>
              <div :id="'renewal' + index" class="accordion-collapse collapse"
                   data-bs-parent="#renewalAccordion">
                <div class="accordion-body">{{ faq.answer }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Still Have Questions -->
    <section class="py-5">
      <div class="container py-5">
        <div class="still-questions-card animate-on-scroll">
          <div class="row align-items-center">
            <div class="col-lg-6 mb-4 mb-lg-0">
              <h3 class="fw-bold mb-3">Still Have Questions?</h3>
              <p class="text-muted mb-0">
                Can't find the answer you're looking for? Our support team is here to help.
                Contact us through any of these channels.
              </p>
            </div>
            <div class="col-lg-6">
              <div class="contact-options">
                <a href="tel:+254700000000" class="contact-option">
                  <div class="co-icon bg-primary">
                    <i class="bx bx-phone"></i>
                  </div>
                  <div class="co-content">
                    <span class="co-label">Call Hotline</span>
                    <span class="co-value">+254 700 000 000</span>
                  </div>
                </a>
                <a href="mailto:support@ponahealth.com" class="contact-option">
                  <div class="co-icon bg-success">
                    <i class="bx bx-envelope"></i>
                  </div>
                  <div class="co-content">
                    <span class="co-label">Email Us</span>
                    <span class="co-value">support@ponahealth.com</span>
                  </div>
                </a>
                <router-link to="/contact" class="contact-option">
                  <div class="co-icon bg-info">
                    <i class="bx bx-map"></i>
                  </div>
                  <div class="co-content">
                    <span class="co-label">Visit Office</span>
                    <span class="co-value">Find Location</span>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Quick Links Section -->
    <section class="py-5 bg-light">
      <div class="container">
        <div class="text-center mb-5 animate-on-scroll">
          <h3 class="fw-bold mb-3">Helpful Resources</h3>
          <p class="text-muted">Quick links to important information</p>
        </div>

        <div class="row g-4">
          <div class="col-lg-3 col-md-6 animate-on-scroll" v-for="link in quickLinks" :key="link.title">
            <router-link :to="link.to" class="quick-link-card">
              <div class="ql-icon" :class="'bg-' + link.color">
                <i :class="link.icon"></i>
              </div>
              <h5 class="fw-bold mb-2">{{ link.title }}</h5>
              <p class="text-muted small mb-0">{{ link.description }}</p>
              <span class="ql-arrow"><i class="bx bx-right-arrow-alt"></i></span>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="py-5 bg-gradient-primary text-white">
      <div class="container py-5">
        <div class="row align-items-center">
          <div class="col-lg-8 animate-on-scroll">
            <h2 class="display-5 fw-bold mb-3 text-white">Ready to Join PONA HEALTH-X?</h2>
            <p class="lead mb-4 mb-lg-0 opacity-75">
              Protect your family with affordable healthcare coverage.
              Visit your nearest enrollment center to get started today.
            </p>
          </div>
          <div class="col-lg-4 text-lg-end animate-on-scroll">
            <router-link to="/enrollment" class="btn btn-light btn-lg mb-3 me-2">
              <i class="bx bx-user-plus me-2"></i>Enroll Now
            </router-link>
            <router-link to="/contact" class="btn btn-outline-light btn-lg mb-3">
              <i class="bx bx-phone me-2"></i>Contact Us
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="bg-dark text-white py-5">
      <div class="container">
        <div class="row g-4">
          <div class="col-lg-4">
            <div class="d-flex align-items-center mb-4">
              <img src="https://pona.paysol.africa/logos/pona.png" alt="PONA HEALTH-X Logo" height="40" class="me-3" style="background: white; padding: 5px; border-radius: 8px;">
              <div>
                <div class="fw-bold">PONA HEALTH-X</div>
                <div class="small text-white-50">Community Health Insurance</div>
              </div>
            </div>
            <p class="text-white-50 mb-4">
              Providing quality healthcare through community-based health insurance.
            </p>
            <div class="social-links">
              <a href="#" class="social-link"><i class="bx bxl-facebook-circle"></i></a>
              <a href="#" class="social-link"><i class="bx bxl-twitter"></i></a>
              <a href="#" class="social-link"><i class="bx bxl-linkedin-square"></i></a>
              <a href="#" class="social-link"><i class="bx bxl-youtube"></i></a>
            </div>
          </div>
          <div class="col-lg-2 col-md-6">
            <h6 class="fw-bold mb-3 text-white">Quick Links</h6>
            <ul class="footer-links">
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/about">About Us</router-link></li>
              <li><router-link to="/benefits">Benefits</router-link></li>
              <li><router-link to="/services">Services</router-link></li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-6">
            <h6 class="fw-bold mb-3 text-white">Resources</h6>
            <ul class="footer-links">
              <li><router-link to="/facilities">Facilities</router-link></li>
              <li><router-link to="/enrollment">Enrollment</router-link></li>
              <li><router-link to="/faqs">FAQs</router-link></li>
              <li><router-link to="/contact">Contact</router-link></li>
            </ul>
          </div>
          <div class="col-lg-4">
            <h6 class="fw-bold mb-3 text-white">Contact Us</h6>
            <ul class="footer-contact">
              <li><i class="bx bx-map me-2"></i>Nairobi, Kenya</li>
              <li><i class="bx bx-phone me-2"></i>+254 700 000 000</li>
              <li><i class="bx bx-envelope me-2"></i>support@ponahealth.com</li>
            </ul>
          </div>
        </div>
        <hr class="my-4 opacity-25">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-start">
            <p class="mb-0 text-white-50 small">
              © 2025 PONA HEALTH-X. All rights reserved.
            </p>
          </div>
          <div class="col-md-6 text-center text-md-end">
            <a href="#" class="text-white-50 small text-decoration-none me-3">Privacy Policy</a>
            <a href="#" class="text-white-50 small text-decoration-none">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>

    <!-- Scroll to Top -->
    <button class="scroll-top-btn" @click="scrollToTop" v-show="showScrollTop">
      <i class="bx bx-chevron-up"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PonaHealthFAQsPage',

  data() {
    return {
      showScrollTop: false,
      searchQuery: '',
      activeCategory: 'all',
      filteredFAQs: [],

      quickStats: [
        { icon: 'bx bx-help-circle', value: '50+', label: 'Questions Answered', color: 'primary' },
        { icon: 'bx bx-category', value: '8', label: 'Categories', color: 'success' },
        { icon: 'bx bx-phone', value: '24/7', label: 'Hotline', color: 'info' },
        { icon: 'bx bx-time', value: '24/7', label: 'Support', color: 'warning' }
      ],

      faqCategories: [
        { id: 'all', name: 'All Questions', icon: 'bx bx-list-ul', count: 50, color: 'primary' },
        { id: 'general', name: 'General', icon: 'bx bx-help-circle', count: 8, color: 'primary' },
        { id: 'enrollment', name: 'Enrollment', icon: 'bx bx-user-plus', count: 7, color: 'success' },
        { id: 'coverage', name: 'Coverage', icon: 'bx bx-shield-check', count: 7, color: 'info' },
        { id: 'premiums', name: 'Premiums', icon: 'bx bx-money', count: 6, color: 'warning' },
        { id: 'facilities', name: 'Facilities', icon: 'bx bx-hospital', count: 6, color: 'purple' },
        { id: 'services', name: 'Services', icon: 'bx bx-first-aid', count: 6, color: 'danger' },
        { id: 'membership', name: 'Membership', icon: 'bx bx-id-card', count: 5, color: 'teal' },
        { id: 'renewal', name: 'Renewal', icon: 'bx bx-refresh', count: 5, color: 'orange' }
      ],

      generalFAQs: [
        {
          question: 'What is PONA HEALTH-X?',
          answer: 'PONA HEALTH-X is a community-based health insurance program designed for informal sector workers and rural communities. It provides affordable healthcare coverage for households who are not covered by formal sector health insurance schemes. PONA HEALTH-X operates on principles of solidarity, equity, and community participation.'
        },
        {
          question: 'Who manages PONA HEALTH-X?',
          answer: 'PONA HEALTH-X is managed by the Pona Health Insurance Cover Agency in partnership with regional health authorities. At the regional level, Regional Health Offices oversee implementation, while local health offices manage day-to-day operations. Local PONA HEALTH-X schemes operate at the community level with community governance.'
        },
        {
          question: 'How is PONA HEALTH-X different from private health insurance?',
          answer: 'Unlike private insurance, PONA HEALTH-X is a subsidized, non-profit program focused on providing affordable coverage to informal sector households. It has no exclusions for pre-existing conditions, no medical examination requirements, and premiums are based on ability to pay rather than health risk. The program subsidizes premiums for indigent households.'
        },
        {
          question: 'How many people are covered by PONA HEALTH-X?',
          answer: 'PONA HEALTH-X continues to expand its coverage across multiple regions with the goal of achieving universal health coverage. Coverage varies by region, with some regions achieving high enrollment rates. Contact your local PONA HEALTH-X office for current enrollment statistics in your area.'
        },
        {
          question: 'Is PONA HEALTH-X mandatory?',
          answer: 'PONA HEALTH-X enrollment is currently voluntary for informal sector households. However, enrollment is encouraged as part of the strategy to achieve universal health coverage. Some regions may have higher enrollment targets and community mobilization efforts to increase participation.'
        },
        {
          question: 'What are the goals of PONA HEALTH-X?',
          answer: 'The main goals of PONA HEALTH-X are: (1) Provide financial protection against healthcare costs, (2) Improve access to quality healthcare services, (3) Reduce out-of-pocket health expenditures, (4) Promote community solidarity and risk pooling, and (5) Contribute to universal health coverage.'
        },
        {
          question: 'When was PONA HEALTH-X started?',
          answer: 'PONA HEALTH-X was established in 2018 as a pilot program in select regions. Following successful pilots, the program has been scaled up to cover additional regions. The Pona Health Insurance Cover Agency was established to strengthen program management and expand coverage.'
        },
        {
          question: 'Is PONA HEALTH-X available in all regions?',
          answer: 'PONA HEALTH-X is expanding to cover more regions over time. However, coverage rates and the number of enrolled households vary by region. Urban areas and developed regions generally have higher enrollment rates than emerging regions. Contact your local health office to check availability in your area.'
        }
      ],

      enrollmentFAQs: [
        {
          question: 'How do I enroll in PONA HEALTH-X?',
          answer: 'To enroll in PONA HEALTH-X, visit your local administration office or designated health facility with the required documents. Enrollment must be done in person - online registration is not currently available. Bring your national ID, passport photos, and household member information. Pay the annual premium and receive your membership card the same day.'
        },
        {
          question: 'What documents do I need to enroll?',
          answer: 'Required documents include: (1) National Identification Card (original and copy), (2) Passport-size photographs (2 per household member), (3) List of household members with names, ages, and relationships. Additional documents may include birth certificates for children, marriage certificate for spouse, and indigency certificate if applying for fee waiver.'
        },
        {
          question: 'Can I enroll online?',
          answer: 'Currently, PONA HEALTH-X enrollment cannot be done online. You must visit your local administration office or designated enrollment center in person. This ensures proper verification of documents and accurate registration of household members. The enrollment process typically takes 30-60 minutes.'
        },
        {
          question: 'Who can enroll in PONA HEALTH-X?',
          answer: 'PONA HEALTH-X is available to informal sector workers and rural communities including farmers, self-employed individuals, small business owners, daily laborers, pastoralists, artisans, and market vendors. Formal sector employees covered by employer-sponsored health insurance schemes are not eligible for PONA HEALTH-X.'
        },
        {
          question: 'Can I enroll at any time of year?',
          answer: 'Yes, PONA HEALTH-X enrollment is open year-round. You can visit your local enrollment center any working day to register. However, some regions may have annual enrollment campaigns with additional support and mobilization. Your coverage begins immediately after registration and premium payment.'
        },
        {
          question: 'How long does the enrollment process take?',
          answer: 'The enrollment process typically takes 30-60 minutes if you have all required documents ready. You will complete a registration form, have your documents verified, pay the premium, and receive your membership card on the same day. Preparation and having all documents ready can speed up the process.'
        },
        {
          question: 'Can someone else enroll on my behalf?',
          answer: 'In general, the head of household should enroll in person. However, in special circumstances (illness, disability), a family member with proper authorization and all required documents may complete the enrollment. Contact your local office to discuss specific situations and required documentation.'
        }
      ],

      coverageFAQs: [
        {
          question: 'What services are covered by PONA HEALTH-X?',
          answer: 'PONA HEALTH-X covers a comprehensive range of services including: outpatient consultations, inpatient hospital care, emergency treatment, maternal and child health services, laboratory tests, essential medicines, basic imaging (X-ray, ultrasound), minor and major surgeries, chronic disease management, and mental health services (basic). Coverage is provided at all PONA HEALTH-X-contracted facilities.'
        },
        {
          question: 'Are pre-existing conditions covered?',
          answer: 'Yes, PONA HEALTH-X covers pre-existing conditions. Unlike private insurance, PONA HEALTH-X does not exclude members based on their current health status. Whether you have diabetes, hypertension, HIV/AIDS, or other chronic conditions, you are eligible for coverage and can receive treatment for these conditions.'
        },
        {
          question: 'Is my family covered under my membership?',
          answer: 'Yes, one PONA HEALTH-X membership covers your entire household including spouse, children under 18, and other dependents living under the same roof. All family members are listed on the membership card and can access healthcare services. There is no additional premium for family members.'
        },
        {
          question: 'What services are NOT covered by PONA HEALTH-X?',
          answer: 'Services generally not covered include: cosmetic and plastic surgery, fertility treatments (IVF), treatment outside the coverage area, experimental treatments, non-essential dental procedures (braces, whitening), services at non-contracted facilities, self-inflicted injuries, injuries from illegal activities, and private room upgrades.'
        },
        {
          question: 'Is there a waiting period before coverage begins?',
          answer: 'No, there is no waiting period for most services. Your coverage starts immediately after enrollment and premium payment. You can access outpatient care, emergency services, and most other services right away with your membership card. Some regions may have specific rules for certain services.'
        },
        {
          question: 'Does PONA HEALTH-X cover emergency care?',
          answer: 'Yes, emergency care is fully covered by PONA HEALTH-X. You can access emergency services at any PONA HEALTH-X-contracted facility without a referral. This includes emergency consultations, trauma care, emergency surgery, resuscitation, and ambulance services where available. Emergency coverage is available 24/7.'
        },
        {
          question: 'Are medicines covered by PONA HEALTH-X?',
          answer: 'Yes, essential medicines on the Essential Medicines List are covered. This includes antibiotics, pain relievers, anti-malarials, chronic disease medications, vitamins (as prescribed), and contraceptives. Medicines are dispensed at facility pharmacies. Some specialty medications may require referral to higher facilities.'
        }
      ],

      premiumsFAQs: [
        {
          question: 'How much does PONA HEALTH-X cost?',
          answer: 'PONA HEALTH-X premiums are based on household economic status. Premium amounts vary by region and household classification. Lower-income households pay reduced rates, while higher-income households may pay standard rates. Indigent households identified by the community receive full subsidy (free coverage). Contact your local office for specific premium rates in your area.'
        },
        {
          question: 'How do I pay my premium?',
          answer: 'Premiums are paid at the time of enrollment or renewal at your local enrollment center. Accepted payment methods include cash, bank transfer, and mobile money (M-Pesa, etc.). You will receive an official receipt upon payment. The premium covers your entire household for 12 months.'
        },
        {
          question: 'What if I cannot afford the premium?',
          answer: 'If you cannot afford the premium, you may be eligible for a fee waiver as an indigent household. Contact your local administration to apply for an indigency certificate. Households identified as indigent receive full premium subsidy and have the same coverage as paying members.'
        },
        {
          question: 'How is my premium amount determined?',
          answer: 'Premium amounts are determined through community-based wealth ranking. Your local administration conducts assessments to classify households into wealth categories (poorest, poor, middle, rich, richest). Your premium tier is based on this classification. The goal is to ensure premiums are affordable based on ability to pay.'
        },
        {
          question: 'Can I pay my premium in installments?',
          answer: 'Currently, PONA HEALTH-X premiums are paid as a single annual payment at the time of enrollment or renewal. However, some regions may offer flexibility for households facing hardship. Contact your local enrollment center to discuss payment options if you are having difficulty with lump-sum payment.'
        },
        {
          question: 'Is there a refund if I don\'t use healthcare services?',
          answer: 'No, PONA HEALTH-X premiums are not refundable if you do not use services during the year. The premium is based on the principle of risk pooling - your contribution helps fund healthcare for other community members who need it. This solidarity principle is fundamental to how PONA HEALTH-X works.'
        }
      ],

      facilitiesFAQs: [
        {
          question: 'Where can I receive healthcare with my PONA HEALTH-X card?',
          answer: 'You can receive care at any PONA HEALTH-X-contracted health facility including health posts, health centers, and hospitals. All public health facilities in participating regions are contracted with PONA HEALTH-X. Some private facilities may also be contracted depending on your region. Look for the PONA HEALTH-X logo or ask at the facility.'
        },
        {
          question: 'How do I find a PONA HEALTH-X facility near me?',
          answer: 'To find a nearby facility: (1) Call our hotline at +254 700 000 000, (2) Visit your local administration office, (3) Ask at any health center, or (4) Contact your regional health office. You can also ask community health workers or neighbors who are PONA HEALTH-X members for guidance to the nearest facility.'
        },
        {
          question: 'Can I visit any hospital I want?',
          answer: 'For primary care, you should visit your designated health center first. For specialized services, you need a referral from your primary facility. However, in emergencies, you can visit any PONA HEALTH-X-contracted facility directly without a referral. Following the referral pathway helps ensure appropriate care.'
        },
        {
          question: 'Do I need a referral to see a specialist?',
          answer: 'Yes, you generally need a referral from your primary healthcare facility (health center) to see a specialist at a hospital. The referral letter ensures your PONA HEALTH-X coverage continues at the higher-level facility. Emergency cases are exempt from the referral requirement.'
        },
        {
          question: 'What if I need care while traveling?',
          answer: 'In emergencies, you can receive care at any PONA HEALTH-X-contracted facility anywhere in the coverage area. For non-emergency care while traveling, it is best to return to your enrolled region or contact your regional health office for guidance on accessing care outside your area.'
        },
        {
          question: 'Are private facilities covered by PONA HEALTH-X?',
          answer: 'Some private facilities have contracts with PONA HEALTH-X, but coverage varies by region. Not all private hospitals and clinics are included. Before visiting a private facility, verify that it is PONA HEALTH-X-contracted by calling our hotline or asking the facility directly. Using non-contracted facilities may require out-of-pocket payment.'
        }
      ],

      servicesFAQs: [
        {
          question: 'What do I need to bring when visiting a facility?',
          answer: 'When visiting a health facility, bring: (1) Your valid PONA HEALTH-X membership card, (2) A form of identification (National ID), (3) Referral letter if you were referred from another facility, (4) Any previous prescriptions or medical records for follow-up visits. Keep your card safe as you will need it for every visit.'
        },
        {
          question: 'Do I have to pay anything at the facility?',
          answer: 'With valid PONA HEALTH-X membership, you should have minimal or no out-of-pocket payment for covered services. Simply present your card at registration. Some advanced services (CT scan, MRI) may require co-payment. If asked to pay for covered services, verify with the facility administrator.'
        },
        {
          question: 'What happens if I need services not available at my facility?',
          answer: 'If your facility cannot provide the services you need, they will refer you to a higher-level facility. You will receive a referral letter to take to the referral hospital. Your PONA HEALTH-X coverage continues at the referral facility. The referral system ensures you get appropriate care while maintaining coverage.'
        },
        {
          question: 'Are laboratory tests covered?',
          answer: 'Yes, laboratory tests are covered when ordered by your healthcare provider. Covered tests include complete blood count (CBC), blood glucose, urinalysis, malaria testing, HIV testing, hepatitis screening, pregnancy tests, TB testing, and basic biochemistry. Tests are ordered based on clinical need.'
        },
        {
          question: 'Is maternal and child healthcare covered?',
          answer: 'Yes, comprehensive maternal and child health services are covered including: antenatal care (all visits), delivery services (normal and assisted), cesarean section when medically indicated, postnatal care, newborn care, family planning, immunization, and growth monitoring. Maternal services are a priority in PONA HEALTH-X.'
        },
        {
          question: 'How do I access emergency services?',
          answer: 'In an emergency, go directly to the nearest PONA HEALTH-X-contracted facility. Emergency services are available 24/7 and do not require a referral. Present your PONA HEALTH-X card when possible, but treatment should not be delayed if you don\'t have your card. Coverage includes emergency consultation, trauma care, and emergency surgery.'
        }
      ],

      membershipFAQs: [
        {
          question: 'What information is on my PONA HEALTH-X card?',
          answer: 'Your PONA HEALTH-X membership card contains: member ID number, head of household name, names of all covered household members, enrollment date, expiry date, region/location information, and a barcode or QR code for verification. Some regions may have digital cards accessible via mobile phone.'
        },
        {
          question: 'What should I do if I lose my card?',
          answer: 'If you lose your PONA HEALTH-X card, visit your local enrollment center (administration office or health facility) to request a replacement. Bring your National ID and passport photo. There may be a small fee for card replacement. Report the loss promptly to prevent misuse of your membership.'
        },
        {
          question: 'Can someone else use my PONA HEALTH-X card?',
          answer: 'No, PONA HEALTH-X cards are non-transferable. Only the household members listed on the card are covered. Facilities may ask for identification to verify membership. Sharing cards is not allowed and may result in loss of membership privileges. Each listed member can use the card for their own healthcare.'
        },
        {
          question: 'How do I add a newborn to my membership?',
          answer: 'Newborns are automatically covered under the mother\'s membership from birth. To officially add the baby to your household membership, visit your enrollment center with the birth certificate within 30 days of birth. The baby\'s name will be added to your membership card at renewal.'
        },
        {
          question: 'How do I update my membership information?',
          answer: 'To update information (address change, add/remove family members, correct errors), visit your local enrollment center with supporting documents. Common updates include adding a new spouse (bring marriage certificate), removing deceased members (bring death certificate), or changing address (bring new residence proof).'
        }
      ],

      renewalFAQs: [
        {
          question: 'When do I need to renew my membership?',
          answer: 'PONA HEALTH-X membership is valid for 12 months from the date of enrollment or last renewal. You should renew 30 days before your expiry date to avoid gaps in coverage. Check the expiry date on your membership card. Your enrollment center may send reminders before expiry.'
        },
        {
          question: 'How do I renew my PONA HEALTH-X membership?',
          answer: 'To renew, visit your local enrollment center before your membership expires. Bring your current PONA HEALTH-X card, National ID, updated passport photos (if required), and the renewal premium payment. The process is similar to initial enrollment but usually faster since your information is already on file.'
        },
        {
          question: 'What happens if I don\'t renew on time?',
          answer: 'If your membership expires without renewal, you will lose coverage and must pay out-of-pocket for healthcare services. You will need to re-enroll as if you are a new member. Some regions may have grace periods, but it is best to renew before expiry to maintain continuous coverage.'
        },
        {
          question: 'Can I renew at a different location?',
          answer: 'If you have moved to a different region, you can transfer your membership to your new location during renewal. Visit your new local office with your current PONA HEALTH-X card, National ID from the new location, and updated residence documents. Your membership will be transferred to the new region.'
        },
        {
          question: 'Is the renewal premium the same as initial enrollment?',
          answer: 'The renewal premium is generally the same as the initial enrollment premium for your wealth category. However, if your household\'s economic status has changed significantly, your premium tier may be reassessed. Subsidies for indigent households continue at renewal.'
        }
      ],

      quickLinks: [
        { title: 'Benefits', description: 'Learn about PONA HEALTH-X coverage benefits', icon: 'bx bx-gift', to: '/benefits', color: 'primary' },
        { title: 'Enrollment', description: 'How to join PONA HEALTH-X', icon: 'bx bx-user-plus', to: '/enrollment', color: 'success' },
        { title: 'Facilities', description: 'Find health facilities', icon: 'bx bx-hospital', to: '/facilities', color: 'info' },
        { title: 'Contact Us', description: 'Get in touch with us', icon: 'bx bx-phone', to: '/contact', color: 'warning' }
      ]
    };
  },

  computed: {
    allFAQs() {
      const faqs = [];

      this.generalFAQs.forEach(faq => {
        faqs.push({ ...faq, categoryName: 'General', categoryColor: 'primary' });
      });
      this.enrollmentFAQs.forEach(faq => {
        faqs.push({ ...faq, categoryName: 'Enrollment', categoryColor: 'success' });
      });
      this.coverageFAQs.forEach(faq => {
        faqs.push({ ...faq, categoryName: 'Coverage', categoryColor: 'info' });
      });
      this.premiumsFAQs.forEach(faq => {
        faqs.push({ ...faq, categoryName: 'Premiums', categoryColor: 'warning' });
      });
      this.facilitiesFAQs.forEach(faq => {
        faqs.push({ ...faq, categoryName: 'Facilities', categoryColor: 'purple' });
      });
      this.servicesFAQs.forEach(faq => {
        faqs.push({ ...faq, categoryName: 'Services', categoryColor: 'danger' });
      });
      this.membershipFAQs.forEach(faq => {
        faqs.push({ ...faq, categoryName: 'Membership', categoryColor: 'teal' });
      });
      this.renewalFAQs.forEach(faq => {
        faqs.push({ ...faq, categoryName: 'Renewal', categoryColor: 'orange' });
      });

      return faqs;
    }
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.observeElements();
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    observeElements() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      document.querySelectorAll('.animate-on-scroll').forEach(el => {
        observer.observe(el);
      });
    },

    goToPage(page) {
      this.$router.push(page);
    },


    filterFAQs() {
      if (!this.searchQuery.trim()) {
        this.filteredFAQs = [];
        return;
      }

      const query = this.searchQuery.toLowerCase();
      this.filteredFAQs = this.allFAQs.filter(faq =>
          faq.question.toLowerCase().includes(query) ||
          faq.answer.toLowerCase().includes(query)
      );
    },

    clearSearch() {
      this.searchQuery = '';
      this.filteredFAQs = [];
    },

    selectCategory(categoryId) {
      this.activeCategory = categoryId;
      this.searchQuery = '';
      this.filteredFAQs = [];
    },

    markHelpful(faq, helpful) {
      // This would typically send to an API
      console.log('FAQ marked as', helpful ? 'helpful' : 'not helpful', faq.question);
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    handleScroll() {
      this.showScrollTop = window.pageYOffset > 300;
    },

    goToMemberLogin() {
      this.$router.push('/member-login');
    },

    goToStaffLogin() {
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
/* ========================================================================= */
/* FAQS PAGE - PROFESSIONAL STYLES */
/* ========================================================================= */

.faqs-page {
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  overflow-x: hidden;
  background: #fafbfc;
}

/* ========================================================================= */
/* NAVIGATION */
/* ========================================================================= */
.navbar {
  padding: 1rem 0;
  transition: all 0.4s ease;
  z-index: 1001;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
}

.brand-title {
  font-weight: 800;
  font-size: 1.1rem;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-subtitle {
  font-size: 0.75rem;
  color: #6c757d;
  font-weight: 600;
}

.nav-link {
  font-weight: 600;
  color: #495057 !important;
  transition: all 0.3s ease;
}

.nav-link:hover,
.nav-link.active {
  color: #2c5aa0 !important;
}

.dropdown-menu {
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  border-radius: 1rem;
  padding: 0.5rem;
}

.dropdown-item {
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  transition: all 0.3s ease;
  font-weight: 500;
}

.dropdown-item:hover {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  transform: translateX(5px);
}

/* ========================================================================= */
/* PAGE HEADER */
/* ========================================================================= */
.page-header {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 50%, #4a90e2 100%);
  padding-top: 120px;
  padding-bottom: 60px;
  position: relative;
  overflow: hidden;
}

.header-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg width="60" height="60" xmlns="http://www.w3.org/2000/svg"><text x="15" y="35" font-size="20" fill="rgba(255,255,255,0.03)">?</text></svg>');
}

.z-2 {
  z-index: 2;
}

.min-vh-40 {
  min-height: 40vh;
}

.breadcrumb-light {
  background: transparent;
  margin: 0;
  padding: 0;
}

.breadcrumb-light .breadcrumb-item a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
}

.breadcrumb-light .breadcrumb-item a:hover {
  color: white;
}

.breadcrumb-light .breadcrumb-item.active {
  color: white;
}

.breadcrumb-light .breadcrumb-item + .breadcrumb-item::before {
  color: rgba(255, 255, 255, 0.5);
}

/* Search Box */
.faq-search {
  max-width: 600px;
  margin: 2rem auto 0;
}

.search-box {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 60px;
  padding: 0.5rem 1.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.search-box i {
  font-size: 1.5rem;
  color: #6c757d;
}

.search-box input {
  flex: 1;
  border: none;
  padding: 1rem;
  font-size: 1.1rem;
  outline: none;
}

.search-box input::placeholder {
  color: #adb5bd;
}

.search-clear {
  background: #f0f0f0;
  border: none;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.search-clear:hover {
  background: #e0e0e0;
}

/* ========================================================================= */
/* QUICK STATS */
/* ========================================================================= */
.quick-stats-section {
  margin-top: -40px;
  position: relative;
  z-index: 10;
  padding-bottom: 2rem;
}

.quick-stats-card {
  background: white;
  border-radius: 1.5rem;
  padding: 2rem;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.15);
}

.quick-stat-item {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.qs-icon {
  width: 55px;
  height: 55px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
  flex-shrink: 0;
}

.qs-value {
  display: block;
  font-size: 1.5rem;
  font-weight: 900;
  color: #1e3f70;
  line-height: 1;
}

.qs-label {
  font-size: 0.85rem;
  color: #6c757d;
}

/* ========================================================================= */
/* SECTION LABELS */
/* ========================================================================= */
.section-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.label-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: #2c5aa0;
}

.label-text {
  font-weight: 700;
  font-size: 0.9rem;
  color: #2c5aa0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Background colors */
.bg-primary { background: linear-gradient(135deg, #2c5aa0, #4a90e2) !important; }
.bg-success { background: linear-gradient(135deg, #28a745, #5cb85c) !important; }
.bg-warning { background: linear-gradient(135deg, #ffc107, #ffda6a) !important; }
.bg-info { background: linear-gradient(135deg, #17a2b8, #5bc0de) !important; }
.bg-danger { background: linear-gradient(135deg, #dc3545, #f1707a) !important; }
.bg-purple { background: linear-gradient(135deg, #6f42c1, #9d7bd1) !important; }
.bg-teal { background: linear-gradient(135deg, #20c997, #63e6be) !important; }
.bg-orange { background: linear-gradient(135deg, #fd7e14, #ffb347) !important; }

.text-purple { color: #6f42c1 !important; }
.text-teal { color: #20c997 !important; }
.text-orange { color: #fd7e14 !important; }

/* ========================================================================= */
/* CATEGORY GRID */
/* ========================================================================= */
.category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
}

.category-card {
  background: white;
  border-radius: 1rem;
  padding: 1.5rem 1rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(44, 90, 160, 0.15);
}

.category-card.active {
  border-color: #2c5aa0;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
}

.category-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  font-size: 1.5rem;
  color: white;
  transition: all 0.3s ease;
}

.category-card:hover .category-icon {
  transform: scale(1.1);
}

.category-count {
  font-size: 0.8rem;
  color: #6c757d;
}

/* ========================================================================= */
/* SEARCH RESULTS */
/* ========================================================================= */
.search-results-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 1rem 1.5rem;
  background: white;
  border-radius: 1rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.results-count {
  background: #e3f2fd;
  color: #2c5aa0;
  padding: 0.5rem 1rem;
  border-radius: 50px;
  font-weight: 700;
  font-size: 0.9rem;
}

.faq-question {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.faq-category-tag {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 700;
  width: fit-content;
}

.tag-primary { background: #e3f2fd; color: #2c5aa0; }
.tag-success { background: #d4edda; color: #28a745; }
.tag-info { background: #d1ecf1; color: #17a2b8; }
.tag-warning { background: #fff3cd; color: #856404; }
.tag-danger { background: #f8d7da; color: #dc3545; }
.tag-purple { background: #e9e3f5; color: #6f42c1; }
.tag-teal { background: #d1f2eb; color: #20c997; }
.tag-orange { background: #ffe5d0; color: #fd7e14; }

.question-text {
  font-weight: 600;
  color: #1e3f70;
}

/* No Results */
.no-results {
  text-align: center;
  padding: 4rem 2rem;
  background: white;
  border-radius: 1.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
}

.no-results-icon {
  width: 100px;
  height: 100px;
  background: #f8f9fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 3rem;
  color: #6c757d;
}

/* ========================================================================= */
/* FAQ SECTIONS */
/* ========================================================================= */
.faq-section {
  margin-bottom: 3rem;
}

.faq-section-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding: 1.5rem;
  background: white;
  border-radius: 1rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.section-icon {
  width: 60px;
  height: 60px;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  color: white;
  flex-shrink: 0;
}

/* FAQ Accordion */
.faq-accordion .accordion-item {
  margin-bottom: 1rem;
  border: none;
  border-radius: 1rem !important;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.faq-accordion .accordion-button {
  font-weight: 600;
  color: #1e3f70;
  background-color: white;
  padding: 1.25rem 1.5rem;
  font-size: 1rem;
}

.faq-accordion .accordion-button:not(.collapsed) {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  color: #1e3f70;
  box-shadow: none;
}

.faq-accordion .accordion-button:focus {
  box-shadow: none;
}

.faq-accordion .accordion-body {
  padding: 1.5rem;
  line-height: 1.8;
  color: #495057;
  background: white;
}

/* FAQ Helpful */
.faq-helpful {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #f0f0f0;
}

.helpful-label {
  font-size: 0.9rem;
  color: #6c757d;
}

.helpful-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 1px solid #e0e0e0;
  background: white;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.helpful-btn:hover {
  background: #f8f9fa;
  border-color: #2c5aa0;
  color: #2c5aa0;
}

/* ========================================================================= */
/* STILL QUESTIONS */
/* ========================================================================= */
.still-questions-card {
  background: white;
  border-radius: 1.5rem;
  padding: 3rem;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.1);
  border: 2px solid #e3f2fd;
}

.contact-options {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.contact-option {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  background: #f8f9fa;
  border-radius: 1rem;
  text-decoration: none;
  transition: all 0.3s ease;
}

.contact-option:hover {
  background: #e3f2fd;
  transform: translateX(10px);
}

.co-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
  flex-shrink: 0;
}

.co-label {
  display: block;
  font-size: 0.8rem;
  color: #6c757d;
}

.co-value {
  display: block;
  font-weight: 700;
  color: #1e3f70;
}

/* ========================================================================= */
/* QUICK LINKS */
/* ========================================================================= */
.quick-link-card {
  display: block;
  background: white;
  border-radius: 1.5rem;
  padding: 2rem;
  text-decoration: none;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
  height: 100%;
}

.quick-link-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(44, 90, 160, 0.15);
}

.ql-icon {
  width: 60px;
  height: 60px;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  font-size: 1.75rem;
  color: white;
  transition: all 0.3s ease;
}

.quick-link-card:hover .ql-icon {
  transform: scale(1.1) rotate(5deg);
}

.quick-link-card h5 {
  color: #1e3f70;
}

.ql-arrow {
  position: absolute;
  bottom: 1.5rem;
  right: 1.5rem;
  width: 40px;
  height: 40px;
  background: #f8f9fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  color: #2c5aa0;
  transition: all 0.3s ease;
}

.quick-link-card:hover .ql-arrow {
  background: #2c5aa0;
  color: white;
  transform: translateX(5px);
}

/* ========================================================================= */
/* CTA */
/* ========================================================================= */
.bg-gradient-primary {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 50%, #4a90e2 100%);
}

/* ========================================================================= */
/* BUTTONS */
/* ========================================================================= */
.btn {
  padding: 0.875rem 2rem;
  border-radius: 0.75rem;
  font-weight: 700;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.btn-primary {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  border-color: transparent;
  color: white;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 100%);
}

.btn-light {
  background: white;
  color: #2c5aa0;
}

.btn-outline-light {
  color: white;
  border-color: white;
}

.btn-outline-light:hover {
  background: white;
  color: #2c5aa0;
}

/* ========================================================================= */
/* FOOTER */
/* ========================================================================= */
footer {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 100%);
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 0.5rem;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-links a:hover {
  color: white;
  padding-left: 8px;
}

.footer-contact {
  list-style: none;
  padding: 0;
}

.footer-contact li {
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-links .social-link {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.social-links .social-link:hover {
  background: white;
  color: #2c5aa0;
  transform: translateY(-5px);
}

/* ========================================================================= */
/* SCROLL BUTTON */
/* ========================================================================= */
.scroll-top-btn {
  position: fixed;
  bottom: 35px;
  right: 35px;
  width: 55px;
  height: 55px;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 8px 25px rgba(44, 90, 160, 0.4);
  transition: all 0.3s ease;
  z-index: 1000;
  font-size: 1.8rem;
}

.scroll-top-btn:hover {
  transform: translateY(-8px) scale(1.1);
  box-shadow: 0 15px 40px rgba(44, 90, 160, 0.6);
}

/* ========================================================================= */
/* ANIMATIONS */
/* ========================================================================= */
.animate-on-scroll {
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.animate-on-scroll.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* ========================================================================= */
/* RESPONSIVE */
/* ========================================================================= */
@media (max-width: 992px) {
  .category-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .still-questions-card {
    text-align: center;
  }

  .contact-options {
    margin-top: 1.5rem;
  }
}

@media (max-width: 768px) {
  .page-header {
    padding-top: 100px;
  }

  .page-header h1 {
    font-size: 2.5rem;
  }

  .category-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .faq-section-header {
    flex-direction: column;
    text-align: center;
  }

  .search-results-header {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .contact-option:hover {
    transform: none;
  }
}

@media (max-width: 576px) {
  .category-grid {
    grid-template-columns: 1fr 1fr;
  }

  .quick-stat-item {
    flex-direction: column;
    text-align: center;
  }
}
</style>